import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { DialogService, DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { MessageService, ConfirmationService, PrimeNGConfig } from 'primeng/api';
import { Title } from '@angular/platform-browser';
import { NavigationService } from '../../../../services/navigation/navigation.service';
import { CommonService } from '../../../../services/common/common.service';
import { CategoriesDataService, CategoriesColumnsService } from '../../../services';
import { Category, CategoriesResult } from '../../../interfaces';
import { Column } from '../../../interfaces/column.interface';

@Component({
  selector: 'app-category-details',
  templateUrl: './category-details.component.html',
  styleUrls: ['./category-details.component.scss'],
  providers: [MessageService, ConfirmationService, DynamicDialogRef, DynamicDialogConfig],
})
export class CategoryDetailsComponent implements OnInit, OnDestroy {

  public category: Category = {};
  public categories: Category[] = [];
  public defaultParameters: {[param: string]: string | string[]} = {offset: '0', limit: '1000'};
  public parameters: {[param: string]: string | string[]} = {offset: '0', limit: '1000'};
  public isLoading: boolean = false;
  public locale: string = (localStorage.language)?localStorage.language:'en';
  public columns: Column[] = [];

  constructor(
    private translate: TranslateService,
    private common: CommonService,
    private router: Router,
    private route: ActivatedRoute,
    private dialogService: DialogService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private dynamicDialogConfig: DynamicDialogConfig,
    private primengConfig: PrimeNGConfig,
    private titleService: Title,
    private categoriesDataService: CategoriesDataService,
    private categoriesColumnsService: CategoriesColumnsService,

  ) { }

  ngOnInit(): void {
    this.route.params.subscribe((params: any) => {
      if (typeof params['id'] !== 'undefined') {
        this.titleService.setTitle('Category - Details');
        this.getCategory(parseInt(params['id'], 10));
      }
    });
    if (this.dynamicDialogConfig.data && typeof this.dynamicDialogConfig.data.category !== 'undefined') {
      this.category = this.dynamicDialogConfig.data.category;
    }
    this.columns = this.categoriesColumnsService.getColumns();
  }

  ngOnDestroy(): void {
  }

  getCategory(id: number): void {
    this.isLoading = true;
    this.categoriesDataService.getCategory(id).subscribe((response: Category|any) => {
      this.isLoading = false;
      if (response !== null) {
        this.category = response;
      }
    });
  }

  list() {
    this.router.navigate(['/categories']);
  }

  add() {
    this.router.navigate(['/categories/add']);
  }

  edit() {
    this.router.navigate(['/categories/edit/' + this.category.id]);
  }

}
@Component({
  selector: 'app-category-details',
  templateUrl: './category-details.component.html',
  styleUrls: ['./category-details.component.scss'],
  providers: [MessageService, ConfirmationService],
})
export class DialogCategoryDetailsComponent extends CategoryDetailsComponent {
}

